module.exports = __webpack_public_path__ + "img/pic-Search failed@2x.cead1829.png";